import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import BaseContainer from './Components/BaseContainer/BaseContainer'

import { BrowserRouter} from 'react-router-dom'

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<BaseContainer>
				<App />
			</BaseContainer>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById('root')
)
